<!-- FUNCTIONNALITIES Start -->
<section class="about-sec wow fadeInUp pb-0 funct_page" data-wow-delay="400ms">
    <div class="container-fluid">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-12 col-md-12">
          <div>
            <h3 class="fw-400">Les Fonctionnalités de 
              <span style="color: #016d6d;">MasterField</span></h3>
          </div>
        </div>
      </div>
    </div>
    <!-- Planification -->
    <div class="container-fluid pt-5 pb-5" style="padding-top: 5% !important;">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-6 col-md-8 text-left">
          <div class="label-box mb-24 functionalities-color">
            <h4 class="badge_fct">Planification</h4>
          </div>
          <div class="mb-24">
            <h4 class="fw-500 functionalities-title">Planifiez les déplacements efficacement</h4>
          </div>
          <p>
            Masterfield révolutionne la gestion des commerciaux sur le terrain
            grâce à une planification minutieuse des visites commerciales.
            Les déplacements pour ces visites sont instantanément transmis
            depuis la console de planification, assurant ainsi une réactivité
            immédiate. De plus, les commerciaux ont la liberté de planifier
            leurs propres déplacement, offrant une flexibilité sans précédent
            pour une gestion efficace de leurs tâches quotidiennes.
          </p><br>
          <ul>
            <li>
                <p class="puce_roles"> 
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Planning hebdomadaire des visites;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Suivi en temps réel des déplacement de vos commerciaux sur terrain;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Visibilité immédiate sur les disponibilité de votre équipe pour attribuer
                    une mission;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Vison étendue pour la planification de la semaine, tout comme la vue quotidienne;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    La définition des objectifs et les actions à entreprendre pour chaque mission;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-5 col-md-3" >
            <div class="about-img-block">
                <div class="row row-gap-4 align-items-center">
                    <div class="col-md-6 working contner">
                        <img class="about-img-1 mb-24 image_capt_right vertical" 
                            src="../../../assets/index/img/functionalities/fonct1-capt1.webp" alt="" style="width: 100% !important;">
                    </div>
                    <div class="col-md-6 working contner">
                        <img class="about-img-3 mb-24 image_capt_right vertical" 
                            src="../../../assets/index/img/functionalities/fonct1-capt2.webp" alt="" style="width: 100% !important;">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- Gestion intelligente -->
    <div class="container-fluid mt-3 pt-5 pb-5">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-4 col-md-3" *ngIf="!mobile">
          <div class="col-lg-12 contner">
            <img class="br-24 icon_roles_section icon_right image_capt_left vertical" 
                src="../../../assets/index/img/functionalities/fonct2-capt1.webp" alt="" style="width: 70% !important;">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
            <div class="label-box mb-24 functionalities-color">
                <h4 class="badge_fct">Gestion intelligente</h4>
            </div>
            <div class="mb-24">
                <h4 class="fw-500 functionalities-title">La gestion intelligente des clients à visiter</h4>
            </div>
            <p>
                Vous bénéficiez d'une gestion optimisée de vos déplacements à
                moindre coût. Notre plateforme utilise des algorithmes avancés pour
                identifier les clients les plus intéressants à visiter en fonction de
                différents critères tels que nombre des visites effectués, et d'autres
                facteurs pertinents. En recommandant les clients les plus
                stratégiques, nous vous aidons à maximiser votre efficacité tout en
                réduisant vos frais de déplacement. Avec MasterField, vous
                disposez des outils nécessaires pour optimiser votre temps et vos
                ressources lors de vos visites commerciales.
            </p><br>
            <ul>
                <li>
                    <p class="puce_roles"> 
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Recommandation des clients stratégiques;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Optimisation du temps et des coûts;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Prise de décisions éclairées;</p>
                </li>
            </ul>
        </div>
        <div class="col-lg-4 col-md-3" *ngIf="mobile">
            <div class="col-lg-12 contner">
              <img class="br-24 icon_roles_section icon_right image_capt_left vertical" 
                  src="../../../assets/index/img/functionalities/fonct2-capt1.webp" alt="" style="width: 100% !important;">
            </div>
          </div>
      </div>
    </div>
    <!-- Gestion des contacts -->
    <div class="container-fluid mt-3 pt-5 pb-5">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-6 col-md-8 text-left">
          <div class="label-box mb-24 functionalities-color">
            <h4 class="badge_fct">Gestion des contacts</h4>
          </div>
          <div class="mb-24">
            <h4 class="fw-500 functionalities-title">Une Gestion des contacts efficace</h4>
          </div>
          <p>
            La gestion des clients par MasterField simplifie et optimise le suivi
            de vos relations d'affaires. Grâce à notre solution, vous pouvez
            centraliser les informations de contact en regroupant toutes les
            données de vos clients en un seul endroit accessible, pour une
            organisation sans faille. vous pouvez segmenter vos contacts en
            les classant et filtrant selon des critères spécifiques tels que le
            secteur d'activité, la localisation et la particularité des clients.
          </p><br>
          <ul>
            <li>
                <p class="puce_roles"> 
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Centralisation des Informations;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Classement et filtrage des clients en fonction du potentiel;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Adaptation de la gestion des contacts à votre modèle d'affaires;</p>
            </li>
            <li>
                <p class="puce_roles">
                    <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                    Enregistrement des contacts dans un espace de stockage sécurisé ;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-5 col-md-3" >
            <div class="about-img-block">
                <div class="row row-gap-4 align-items-center">
                    <div class="col-md-6 working contner">
                        <img class="about-img-1 mb-24 image_capt_right vertical" 
                            src="../../../assets/index/img/functionalities/fonct3-capt1.webp" alt=""  style="width: 100% !important;">
                    </div>
                    <div class="col-md-6 working contner">
                        <img class="about-img-3 mb-24 image_capt_right vertical" 
                            src="../../../assets/index/img/functionalities/fonct3-capt2.webp" alt="" style="width: 100% !important;">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- Gestion des congés -->
    <div class="container-fluid mt-3 pt-5 pb-5">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-5 col-md-3" *ngIf="!mobile">
            <div class="about-img-block">
                <div class="row row-gap-4 align-items-center">
                    <div class="col-md-6 working contner">
                        <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct4-capt1.webp" alt="" style="width: 100% !important;">
                    </div>
                    <div class="col-md-6 working contner">
                        <img class="about-img-3 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct4-capt2.webp" alt="" style="width: 100% !important;">
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-8 text-left">
            <div class="label-box mb-24 functionalities-color">
                <h4 class="badge_fct">Gestion des congés</h4>
            </div>
            <div class="mb-24">
                <h4 class="fw-500 functionalities-title">Simplifiez la gestion des Congés</h4>
            </div>
            <p>
                La solution offre une vision instantanée des absences et des
                congés, qu'il s'agisse de congés payés, de congés maladie,
                de congés sans solde ou d'autres types de congés. Les
                membres de votre équipe peuvent facilement soumettre leurs
                demandes de congé en ligne, avec la possibilité de joindre un
                justificatif si nécessaire et peuvent suivre le statut en temps
                réel. <br>
                Utilisez MasterField pour une planification optimisée,
                garantissant ainsi une meilleure couverture des périodes de
                pointe et évitant les conflits gênants.
            </p><br>
            <ul>
                <li>
                    <p class="puce_roles"> 
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Contrôle totale des demandes de congés;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Gestion proactive des périodes de pointe;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Flexibilité pour le gestionnaire et les collaborateurs;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Visibilité et transparence;</p>
                </li>
            </ul>
        </div>
        <div class="col-lg-5 col-md-3" *ngIf="mobile">
            <div class="about-img-block">
                <div class="row row-gap-4 align-items-center">
                    <div class="col-md-6 working contner">
                        <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct4-capt1.webp" alt="" style="width: 100% !important;">
                    </div>
                    <div class="col-md-6 working contner">
                        <img class="about-img-3 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct4-capt2.webp" alt="" style="width: 100% !important;">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- Rapport paramétrable -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
            <div class="col-lg-1"></div>
            <div class="col-lg-6 col-md-8 text-left">
                <div class="label-box mb-24 functionalities-color">
                <h4 class="badge_fct">Rapport paramétrable</h4>
                </div>
                <div class="mb-24">
                <h4 class="fw-500 functionalities-title">Générez des rapports personnalisables</h4>
                </div>
                <p>
                    MasterField convertit les données brutes saisies en informations
                    présentées de manière claire. La solution permet de générer des
                    rapports personnalisés, adaptés à l'activité de l'entreprise et au
                    contexte des visites commerciales.
                </p><br>
                <ul>
                <li>
                    <p class="puce_roles"> 
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Élaboration des rapports;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Rapports entièrement paramétrable;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Téléchargement des rapports en format PDF;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Enregistrement des rapports dans un espace de stockage;</p>
                </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-3" >
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-6 working contner">
                            <img class="about-img-1 mb-24 image_capt_right vertical" 
                                src="../../../assets/index/img/functionalities/fonct5-capt1.webp" alt="" style="width: 100% !important;" >
                        </div>
                        <div class="col-md-6 working contner">
                            <img class="about-img-3 mb-24 image_capt_right vertical" 
                                src="../../../assets/index/img/functionalities/fonct5-capt2.webp" alt="" style="width: 100% !important;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Enquête de satisfaction -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
          <div class="col-lg-1"></div>
          <div class="col-lg-4 col-md-3" *ngIf="!mobile">
              <div class="about-img-block">
                  <div class="row row-gap-4 align-items-center">
                      <div class="col-md-12 working contner">
                          <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct6-capt1.webp" alt="" style="width: 80% !important;">
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-lg-7 col-md-8 text-left">
              <div class="label-box mb-24 functionalities-color">
                  <h4 class="badge_fct">Enquête de satisfaction</h4>
              </div>
              <div class="mb-24">
                  <h4 class="fw-500 functionalities-title">Obtenez des Retours Précieux
                    et Améliorez Vos Services</h4>
              </div>
              <p>
                Améliorez la satisfaction client avec notre fonctionnalité
                d'enquêtes de satisfaction envoyées automatiquement après
                chaque visite commerciale. Obtenez des retours clients précieux
                pour affiner et optimiser vos services. Nos enquêtes de
                satisfaction personnalisables maximisent les taux de réponse et
                fournissent des données précises et exploitables. En analysant
                ces retours clients, identifiez les domaines d'amélioration,
                renforcez vos relations client et boostez leur fidélité.
              </p><br>
              <ul>
                  <li>
                      <p class="puce_roles"> 
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Feedback directe des clients;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Amélioration de la satisfaction client;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Paramétrage de l'envoi automatique de l'enquête de satisfaction;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Identification des domaine d'amélioration pour fidéliser les clients;</p>
                  </li>
              </ul>
          </div>
          <div class="col-lg-4 col-md-3" *ngIf="mobile">
            <div class="about-img-block">
                <div class="row row-gap-4 align-items-center">
                    <div class="col-md-12 working contner">
                        <img class="about-img-1 mb-24 image_capt_left vertical" 
                          src="../../../assets/index/img/functionalities/fonct6-capt1.webp" alt="" style="width: 100% !important;">
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    <!-- Suivi des performances -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
            <div class="col-lg-1"></div>
            <div class="col-lg-7 col-md-8 text-left">
                <div class="label-box mb-24 functionalities-color">
                <h4 class="badge_fct">Suivi des performances</h4>
                </div>
                <div class="mb-24">
                    <h4 class="fw-500 functionalities-title">Maximisez la performance :
                        Suivi, Statistique , Rentabilité</h4>
                </div>
                <p>
                    Optimisez la rentabilité de votre entreprise en exploitant une
                    analyse détaillée des performances de votre équipe. Notre
                    plateforme offre un suivi en temps réel des données essentielles,
                    telles que les actions faites ou non faites, les visites achevées et
                    les rapports générés, permettant favorisant ainsi une amélioration
                    de l'efficacité opérationnelle. Explorez dès maintenant comment
                    MasterField peut devenir votre allié pour des résultats rentables et
                    durables dans le domaine de gestion de la productivité.
                </p><br>
                <ul>
                <li>
                    <p class="puce_roles"> 
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Mesurez la performance commerciale de votre équipe;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Suivez toutes vos données opérationnelles et commerciale depuis
                        un seul et même tableau;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Vos données centralisées pour vous aider dans vos décisions;</p>
                </li>
                </ul>
            </div>
            <div class="col-lg-4 col-md-3" >
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-6 working contner">
                            <img class="about-img-1 mb-24 image_capt_right vertical" 
                                src="../../../assets/index/img/functionalities/fonct7-capt1.webp" alt="" style="width: 100% !important;">
                        </div>
                        <div class="col-md-6 working contner">
                            <img class="about-img-3 mb-24 image_capt_right vertical" 
                                src="../../../assets/index/img/functionalities/fonct7-capt2.webp" alt="" style="width: 100% !important;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Notification -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
            <div class="col-lg-1"></div>
            <div class="col-lg-4 col-md-3" *ngIf="!mobile">
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-12 working contner">
                          <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct8-capt1.webp" alt="" style="width: 70% !important;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-md-8 text-left">
                <div class="label-box mb-24 functionalities-color">
                    <h4 class="badge_fct">Notification</h4>
                </div>
                <div class="mb-24">
                    <h4 class="fw-500 functionalities-title">Restez informez en temps réel</h4>
                </div>
                <p>
                    Optimisez votre communication par e-mail grâce à notre système
                    de notifications paramétrable. Que vous soyez commercial ou
                    directeur, restez informé des événements clés : recevez des
                    alertes lorsque les visites planifiées sont approuvées ou refusées,
                    planifiez les visites de la semaine et restez au courant des.
                    nouveaux clients. Améliorez votre efficacité opérationnelle tout en
                    réduisant les risques de perte des clients
                </p><br>
                <ul>
                  <li>
                      <p class="puce_roles"> 
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Notification en temps réel;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Gestion de portefeuille client optimisée avec notifications automatiques;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Paramétrage des notifications selon vos besoins;</p>
                  </li>
              </ul>
            </div>
            <div class="col-lg-4 col-md-3" *ngIf="mobile">
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-12 working contner">
                          <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct8-capt1.webp" alt="" style="width: 100% !important;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Messagerie -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
            <div class="col-lg-1"></div>
            <div class="col-lg-7 col-md-8 text-left">
                <div class="label-box mb-24 functionalities-color">
                <h4 class="badge_fct">Messagerie</h4>
                </div>
                <div class="mb-24">
                    <h4 class="fw-500 functionalities-title">Facilitez les Échanges avec votre équipe</h4>
                </div>
                <p>
                    Améliorez la collaboration au sein de votre équipe avec notre
                    messagerie interne sécurisée. Notre solution de messagerie
                    instantanée permet des échanges rapides et efficaces entre
                    collaborateurs, réduisant ainsi les délais de communication et
                    augmentant la productivité. Grâce à une interface conviviale, vous
                    pouvez envoyer des messages privés, partager des fichiers en
                    toute sécurité et recevoir des notifications en temps réel. Facilitez
                    le travail d'équipe , résolvez les problèmes plus rapidement et
                    maintenez une communication fluide au sein de votre entreprise;
                </p><br>
                <ul>
                <li>
                    <p class="puce_roles"> 
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Communication fluide sans friction au sien de l'entreprise;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Échanges rapides et efficaces entre collaborateurs;</p>
                </li>
                <li>
                    <p class="puce_roles">
                        <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                        Partage de fichiers en tout sécurité;</p>
                </li>
                </ul>
            </div>
            <div class="col-lg-4 col-md-3" >
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-12 working contner">
                            <img class="about-img-1 mb-24 image_capt_right vertical" 
                                src="../../../assets/index/img/functionalities/fonct9-capt1.webp" alt="" style="width: 100% !important;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Agenda -->
    <div class="container-fluid mt-3 pt-5 pb-5">
        <div class="row row-gap-4 align-items-center">
            <div class="col-lg-1"></div>
            <div class="col-lg-5 col-md-4" *ngIf="!mobile">
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-6 working contner">
                          <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct10-capt1.webp" alt="" style="width: 100% !important;">
                        </div>
                        <div class="col-md-6 working contner">
                            <img class="about-img-1 mb-24 image_capt_left vertical" 
                                src="../../../assets/index/img/functionalities/fonct10-capt2.webp" alt="" style="width: 100% !important;">
                          </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-7 text-left">
                <div class="label-box mb-24 functionalities-color">
                    <h4 class="badge_fct">Agenda</h4>
                </div>
                <div class="mb-24">
                    <h4 class="fw-500 functionalities-title">Maîtrisez Votre Agenda Professionnel</h4>
                </div>
                <p>
                    Retrouvez toutes vos visites planifiées en un seul endroit grâce à
                    notre agenda intuitif et facile à utiliser. Suivez vos activités avec
                    une vue hebdomadaire et mensuelle pour une organisation
                    optimale. Notre agenda vous permet de rester organisé et de ne
                    rien oublier. Améliorez votre productivité en visualisant vos
                    disponibilités et celles de votre équipe en un coup d'œil. Optimisez
                    la gestion de votre temps et simplifiez la planification de vos
                    visites clients
                </p><br>
                <ul>
                  <li>
                      <p class="puce_roles"> 
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Vue hebdomadaire et mensuelle pour une organisation optimale;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Centralisation de toutes vos visites planifiées en un seul endroit;</p>
                  </li>
                  <li>
                      <p class="puce_roles">
                          <img src="../../../assets/index/img/advantages/puce.gif" class="puce_icone" alt="">
                          Interface intuitive facile à utiliser pour rester organisé;</p>
                  </li>
              </ul>
            </div>
            <div class="col-lg-5 col-md-4" *ngIf="mobile">
                <div class="about-img-block">
                    <div class="row row-gap-4 align-items-center">
                        <div class="col-md-6 working contner">
                          <img class="about-img-1 mb-24 image_capt_left vertical" 
                            src="../../../assets/index/img/functionalities/fonct10-capt1.webp" alt="" style="width: 100% !important;">
                        </div>
                        <div class="col-md-6 working contner">
                            <img class="about-img-1 mb-24 image_capt_left vertical" 
                                src="../../../assets/index/img/functionalities/fonct10-capt2.webp" alt="" style="width: 100% !important;">
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  <!-- FUNCTIONNALITIES End -->